import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine13 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#82C8E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4674 5.21451C18.1705 5.21451 19.7096 6.7912 19.7096 8.55573C19.7096 9.92581 18.9776 10.9769 17.5697 11.5025V11.5403C19.034 11.8218 20.1414 12.9104 20.1414 14.7689C20.1414 17.0963 18.0578 18.9545 14.9798 18.9537C13.2719 18.9537 12.2396 18.5598 11.1696 17.959L12.183 15.913C12.7463 16.345 13.6663 16.7765 14.7923 16.7765C16.3314 16.7765 17.2888 15.9509 17.2888 14.8244C17.2888 13.3043 16.125 12.8162 14.7732 12.8162H13.4031V10.62H14.792C16.0872 10.62 16.8943 9.9819 16.8943 8.96816C16.8943 8.12373 16.256 7.39146 14.8671 7.39146C13.647 7.39146 12.8399 7.97346 12.4082 8.34886L11.4883 6.39677C12.6333 5.64599 13.9095 5.21451 15.4674 5.21451ZM9.32182 5.44016V18.6921H6.50652V8.27425C6.056 8.63086 4.72347 9.32529 4.23539 9.56946L3.54069 9.92607L2.63965 7.89886L3.44678 7.52346C4.98591 6.79173 6.41234 5.90946 7.01313 5.44016H9.32182Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine13);
export { ForwardRef as ReactComponent };
